import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiGetArticle } from '../services/api';
import PageHeader from '../components/PageHeader';
import ErrorBanner from '../components/ErrorBanner';
import ArticleView from '../components/ArticleView';
import { UI } from '../constants/colors';
import './Article.css';

const Article = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getToken } = useAuth();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadArticle = useCallback(() => {
    setLoading(true);
    setError(null);
    apiGetArticle(id, getToken())
      .then(setArticle)
      .catch((err) => setError(err.message || 'Article introuvable.'))
      .finally(() => setLoading(false));
  }, [id, getToken]);

  useEffect(() => { loadArticle(); }, [loadArticle]);

  if (loading) {
    return (
      <div className="article-page">
        <PageHeader title="Article" />
        <p style={{ textAlign: 'center', padding: '3rem 1rem', color: UI.textEmpty }}>Chargement…</p>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="article-page">
        <PageHeader title="Article" />
        <ErrorBanner message={error || 'Article introuvable.'} onRetry={loadArticle} />
      </div>
    );
  }

  // Le rendu vit dans ArticleView, partagé avec l'aperçu de l'espace rédaction :
  // l'éditrice voit exactement ce que la lectrice verra.
  return (
    <div className="article-page">
      <PageHeader title="Article" />
      <ArticleView
        article={article}
        onSelectSimilar={(similarId) => navigate(`/article/${similarId}`)}
      />
    </div>
  );
};

export default Article;
